<form [formGroup]="form" class="application-form-container" fxLayout="column">

    <div *ngIf="!fileUploaded" fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="center center"
         fxLayoutAlign.lt-md="start start"
         fxLayoutGap="10px" class="main-container stepper pt-20">
        <ng-container *ngFor="let step of STEPS; let i=index">
            <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px">
                <div [ngClass]="currentStep >= i+1 ? 'circle' : 'circle disabled'" fxLayoutAlign="center center">
                    <div class="number" fxLayoutAlign="center center">{{i + 1}}</div>
                </div>
                <div [ngClass]="currentStep >= i+1 ? 'subtitle' : 'subtitle disabled'">
                    {{(step)|i18n}}
                </div>
            </div>
            <div *ngIf="i+1 !== STEPS.length" class="line" fxFlex fxShow.lt-md="false"></div>
            <div *ngIf="i+1 !== STEPS.length" class="bar" fxFlex fxShow.gt-sm="false"></div>
        </ng-container>
    </div>
    <!-- STEP 1-->
    <ng-container *ngIf="currentStep === 1">
        <div fxLayout="column" class="panel" fxLayoutGap="16px">
            <span class="text-0">{{"How would you like to fill the statistical profile of each subject?"|i18n}}</span>
            <div fxLayout="row" fxLayoutAlign="center stretch">
                <mat-radio-group fxLayout="column" fxLayoutAlign="space-evenly stretch" formControlName="radioGroup"
                                 fxLayoutGap="16px">
                    <mat-radio-button [value]="'radioStat'"
                                      [checked]="false"
                                      (change)="onSelectUploadMode(ECMembersUploadTemplateType.STATISTICAL)">
                        <span class="text-2">{{ "Insert the total yearly consumption in kWh" | i18n}} </span>
                        <app-icon name="fas-info-circle"
                                  [title]="('By entering a total consumption, the monthly withdrawal and injection data are calculated ' +
                                   'according to seasonal statistics and taking into account the self-consumption deriving from the connected production plants.'|i18n)">
                        </app-icon>
                    </mat-radio-button>
                    <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="16px" fxFlex>
                        <mat-radio-button #monthlyRadio [value]="'radioMonth'">
                            <span class="text-2">{{"Insert values month by month:" | i18n }}</span>
                        </mat-radio-button>
                        <div class="mat-select" fxFlex="40">
                            <mat-select formControlName="monthlyMat" app-small-select
                                        (selectionChange)="onSelectUploadMode($event.value)"
                                        [disabled]="!monthlyRadio.checked">
                                <mat-option *ngFor="let templateType of TEMPLATE_TYPES| keyvalue"
                                            [value]="templateType.value">
                                    {{templateType.key|i18n}}
                                </mat-option>
                            </mat-select>
                        </div>
                    </div>
                </mat-radio-group>
            </div>
        </div>
    </ng-container>

    <!-- STEP 2-->
    <ng-container *ngIf="currentStep === 2">
        <div class="panel-nobg" fxLayout="column" fxLayoutAlign="center stretch" fxLayoutGap="10px">
            <div fxLayout="column" fxLayoutAlign="center center" class="download-description">
                <span class="text-2">{{"Download the Excel template, complete it with your subject data and re-upload the file."|i18n}}</span>
                <span class="text-2">{{"This will also create subject-related PODs and facilities."|i18n}}</span>
            </div>
            <div fxLayout="column" fxLayoutAlign="center stretch" class="download-box" fxFlex fxLayoutGap="20px">
                <div fxLayout="row" fxLayoutAlign="center center">
                    <app-icon class="fa-icon" name="fal-download"></app-icon>
                </div>
                <div fxLayout="row" fxLayoutAlign="center center">
                    <span class="text-0">{{"1. Download and fill excel template"|i18n}}</span>
                </div>
                <div fxLayout="row" fxLayoutAlign="center center">
                    <button app-primary-button
                            (click)="onClickDownloadTemplate()">
                        {{'Download template'|i18n}}
                    </button>
                </div>
            </div>
        </div>

    </ng-container>

    <!-- STEP 3-->
    <ng-container *ngIf="currentStep === 3">
        <div class="panel-nobg" fxLayout="column" fxLayoutAlign="center stretch" fxLayoutGap="10px">
            <span class="text-2">{{"Compile the file remembering that:"|i18n}}</span>
            <ul class="text-2">
                <li>{{"fields with an asterisk are mandatory;" | i18n }}</li>
                <li>{{"you can add or remove rows of content, without affecting the columns;" | i18n }}</li>
                <li>{{"Prosumer and Producer PODs require “entry” to be filled out;" | i18n }}</li>
                <li>{{"you will have to respect the instructions present as notes in the Excel file;" | i18n }}</li>
                <li>{{"you cannot change existing data by re-uploading the file;" | i18n }}</li>
                <li>{{"you can upload a maximum of 100 subjects;" | i18n }}</li>
                <li>{{"make sure that the Energy Community has an activation date before specifying it for the subjects." | i18n }}
                    <br>
                    {{"Remember that subjects activation date must follow the Energy Community activation date;" | i18n }}
                </li>

            </ul>
            <span class="text-2">{{"To update the data of an existing subject, you will need to click on the edit button on the page."|i18n}}</span>
        </div>
    </ng-container>

    <!-- STEP 4-->
    <ng-container *ngIf="currentStep === 4">
        <div class="panel-nobg" fxLayout="column" fxLayoutAlign="stretch" fxLayoutGap="10px">
            <div fxLayout="row" fxLayoutAlign="center center" class="download-description">
                <span class="text-2">{{"Download the Excel template, complete it with your subject data and re-upload the file."|i18n}}</span>
            </div>
            <div fxLayout="column" fxLayoutAlign="center stretch"
                 class="{{templateChosen ? 'download-box-selected' : 'download-box'}}" fxFlex fxLayoutGap="20px">
                <div fxLayout="row" fxLayoutAlign="center center">
                    <app-icon class="fa-icon" name="fal-upload"></app-icon>
                </div>
                <div fxLayout="row" fxLayoutAlign="center center">
                    <span class="text-0">{{"2. Upload changed file"|i18n}}</span>
                </div>
                <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="20px">
                    <span class="txt-p-16-4">{{'Edited file:'|i18n}}</span>
                    <input #fileSelect type="file" style="display: none"
                           [accept]="XLSX_MIME_TYPE"
                           (change)="onClickUploadTemplate($event)">
                    <button app-primary-button
                            (click)="fileSelect.click()">
                        <app-icon [name]="templateChosen ? 'fal-sync' : 'fal-search'"></app-icon>
                        {{(templateChosen ? 'Change file' : 'Select file')|i18n}}
                    </button>
                    <span *ngIf="this.template?.name" class="txt-p-16-4">{{this.template?.name}}</span>
                    <div *ngIf="!this.template.name"
                         class="txt-s-14-4">{{'No file uploaded'|i18n}}</div>
                    <button *ngIf="templateChosen" app-icon-button class="app-button-alert"
                            (click)="onClickTrashTemplate(fileSelect)">
                        <app-icon name="fal-trash-alt"></app-icon>
                    </button>
                </div>
                <span fxLayoutAlign="center center" class="txt-s-14-4">
                                        {{'(Max {0} MB. Accepts only XLSX files.)'|i18n:MAX_FILE_MB}}
                                    </span>
            </div>
        </div>
    </ng-container>

    <div fxLayout="row" fxLayoutAlign="space-evenly" class="mt-42">
        <button *ngIf="currentStep === 1" app-ghost-button type="button"
                [mat-dialog-close]="false">
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px">
                <app-icon name="fal-times"></app-icon>
                <span>{{'Cancel'|i18n}}</span>
            </div>
        </button>
        <button *ngIf="currentStep > 1 && !fileUploaded" app-ghost-button type="button"
                (click)="prevStep()">
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px">
                <app-icon name="fal-arrow-left"></app-icon>
                <span>{{'Back'|i18n}}</span>
            </div>
        </button>
        <button *ngIf="currentStep < STEPS.length" app-primary-button type="button"
                [disabled]="!isNextEnabled(currentStep)"
                (click)="nextStep()">
            <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="20px">
                <span>{{'Forward'|i18n}}</span>
                <app-icon name="fal-arrow-right" class="right-icon"></app-icon>
            </div>
        </button>
        <button *ngIf="currentStep === STEPS.length" app-primary-button type="button"
                [disabled]="!templateChosen"
                (click)="sendIt()"
                [matDialogClose]="true">
            <app-icon name="fal-check-circle"></app-icon>
            {{'Save'|i18n}}
        </button>
    </div>

</form>
